import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle } from "lucide-react";
import { firstRunApi } from "../lib/api";
import { useCompany } from "../masters/reference";
import { useLoad } from "../ui/useLoad";
import { toUrl } from "./routes";

// On Today until the company is set up (or the person hides it): the steps, each done or not, with where to do it
export function GettingStarted() {
  const { company } = useCompany();
  const key = `books.setupHidden.${company.id}`;
  const [hidden, setHidden] = useState(() => { try { return localStorage.getItem(key) === "1"; } catch { return false; } });
  const { data } = useLoad(() => firstRunApi.status(company.id), [company.id]);
  if (!data) return null;
  const left = data.steps.filter((s) => !s.done && !s.optional);
  if (data.sample) return <p className="notice small">This is a practice company with made-up figures. Try anything here — it doesn't count against your plan. Delete it under Settings › Security and data when you're done.</p>;
  if (hidden || left.length === 0) return null;
  const hide = () => { try { localStorage.setItem(key, "1"); } catch { /* private window */ } setHidden(true); };
  return (
    <section className="card today-box getting-started">
      <header><h2>Getting started · {data.done} of {data.of}</h2><button className="link small" onClick={hide}>Hide</button></header>
      <ol className="setup-steps">{data.steps.map((s) => <li key={s.key} className={s.done ? "done" : ""}>
        {s.done ? <CheckCircle2 size={16} aria-label="done" /> : <Circle size={16} aria-label="to do" />}
        {s.done ? <span>{s.title}</span> : <Link to={toUrl(s.path)}>{s.title}</Link>}
        <span className="code">{s.code}</span>{!s.done && s.note && <span className="muted small"> · {s.note}</span>}{s.optional && !s.done && <span className="muted small"> (if it applies)</span>}
      </li>)}</ol>
    </section>
  );
}
